// Disable so that we can use a natural semantic order (small to large)
/* eslint-disable sort-keys */
import { css } from "styled-components";

const s = css`
  border-radius: 0.125rem;
`;
const m = css`
  border-radius: 0.25rem;
`;
const l = css`
  border-radius: 0.5rem;
`;
const xl = css`
  border-radius: 1rem;
`;
const xxl = css`
  border-radius: 2rem;
`;
const circle = css`
  border-radius: 50%;
`;

export const corners = {
  s,
  m,
  l,
  xl,
  xxl,
  circle,
};
